import React, {useEffect, useState} from "react";

import {fetchUserInfo, fetchFeatureInfo} from "../../shared/api-service";
import AppContext, {AppContextDefault} from "./App.context";

import {accessStatus} from "../../shared/enums";

const AppContextProvider = ({checkAuthentication, children, logout}) => {

    const [state, setState] = useState(AppContextDefault);

    const npiFromRequestData = npiData => {
        return npiData[0].providerNumbers.find(item => item.numberType === 'NPI').number;
    }

    const providerInfoFromRequestData = npiData => {
        let providerFirstName;
        let providerLastName;
        let providerType;
        let providerDesc;
        let providerPhone;
        let providerNameType;
        if (npiData[0]) { 
            
            if (npiData[0].providerNames[0] && npiData[0].providerNames[0].personName) {
                providerLastName = npiData[0].providerNames[0].personName.lastName;
                providerFirstName = npiData[0].providerNames[0].personName.firstname;
            }
            if (npiData[0].providerProviderType[0]) {
                providerType = npiData[0].providerProviderType[0].typeCode
                providerDesc = npiData[0].providerProviderType[0].typeDesc
            }
            if (npiData[0].providerDemographics[0] && npiData[0].providerDemographics[0].communication && npiData[0].providerDemographics[0].communication.phone) {
                providerPhone = npiData[0].providerDemographics[0].communication.phone.number
            }
            if(npiData[0].providerNames[0] && npiData[0]?.providerNames[0].nameType) {
                providerNameType = npiData[0]?.providerNames[0].nameType;
            }
        }
        providerFirstName = providerFirstName ? providerFirstName : ''
        providerLastName  = providerLastName ? providerLastName : ''
        providerType      = providerType ? providerType === 'SVP' ? 'PH' : 'PR' : ''
        providerPhone     = providerPhone ? providerPhone : ''
        return {providerFirstName, providerLastName, providerType, providerNameType, providerDesc, providerPhone}
    }

    const updateAuthState = async () => {
        let currentState = {...AppContextDefault};
        const res = await checkAuthentication();
        if (res && res !== 'ERROR') {
            currentState.user = res.name || null;
            currentState.access = accessStatus.AUTHENTICATED_ONLY;

            const npi = localStorage.getItem('npi');
            if (npi) {
                try {                                
                    const npiData = await fetchUserInfo(npi)
                    if (npiData) {
                        currentState.npiNumber = npiFromRequestData(npiData)
                        currentState.provider = providerInfoFromRequestData(npiData)
                        currentState.access = accessStatus.AUTHORIZED;
                        const featureData = await fetchFeatureInfo()
                        currentState.showMainModal = featureData.showModal[0] === 'true'
                        currentState.mainModalText = featureData.modalText[0]
                    }
                } catch (e) {}
            }
        } else {
            currentState.access = accessStatus.UNAUTHENTICATED;
        }
        setState(currentState)
    }

    const isLoggedIn = () => [accessStatus.AUTHENTICATED_ONLY, accessStatus.AUTHORIZED].includes(state.access);

    useEffect(() => {
        updateAuthState();
    // eslint-disable-next-line
    }, [])

    const value = {...state, logout, isLoggedIn}
    return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}
export default AppContextProvider;